export function WeaveIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M3 9h12M19 9h2" />
      <path d="M3 15h2M9 15h12" />
      <path d="M7 3v4M7 11v10" />
      <path d="M17 3v10M17 17v4" />
    </svg>
  );
}
